export default "__VITE_ASSET__aio1y0Nh__"